module.exports = "<div [innerHtml]=\"sanitizedHtml\"></div>\n"